import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class SubcontractedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/subcontracted-jobs-report/',
            totalSubcontractedJobs:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Subcontracted Jobs Report',
            isDownloading:false
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                totalSubcontractedJobs: response.jobs,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "DATE,ACV,ACV TRUCK,BVL,CND,G4,SCCD\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totalSubcontractedJobs = [];
        let downloadCsvData = [];
        if(this.state.totalSubcontractedJobs.length > 0){
            let totalLength =(this.state.totalSubcontractedJobs.length - 1);
            
            this.state.totalSubcontractedJobs.map((job, index) => {
                totalSubcontractedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16">
                            {(totalLength != index) ?
                                moment(job.driver_completed_at).format("DD.MM.YYYY") :
                                job.driver_completed_at
                            }
                        </td>
                        <td>{ job.acvTotal}</td> 
                        <td>{ job.acvtruckTotal}</td> 
                        <td>{ job.bvlTotal}</td> 
                        <td>{ job.cndTotal}</td> 
                        <td>{ job.g4Total}</td> 
                        <td>{ job.sccdTotal}</td> 
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                ((totalLength != index) ? moment(job.driver_completed_at).format("DD.MM.YYYY") : job.driver_completed_at)+','+
                        job.acvTotal+','+
                        job.acvtruckTotal+','+
                        job.bvlTotal+','+
                        job.cndTotal+','+
                        job.g4Total+','+
                        job.sccdTotal+"\n";
            });
            
        }else{
            totalSubcontractedJobs.push(
               <tr key='no-records'><td colSpan="7" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Subcontracted Jobs Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                   <tr>
                                        <th>Date</th>
                                        <th>ACV</th>
                                        <th>ACV TRUCK</th>
                                        <th>BVL</th>
                                        <th>CND</th>
                                        <th>G4</th>
                                        <th>SCCD</th>
                                   </tr>
                                </thead> 
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="7"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalSubcontractedJobs}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-subcontracted_jobs_report')) {
    ReactDOM.render(
        <SubcontractedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-subcontracted_jobs_report')
    );
}
